import React, { useEffect, useMemo, useState } from "react";
import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  ResponsiveContainer,
  LabelList,
} from "recharts";
// import { scaleQuantize } from 'd3-scale';
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import HourglassTopIcon from "@mui/icons-material/HourglassTop";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import axios from "axios";
import { API_URL, AUTH_URL, CHAT_URL } from "../../utils/constants";
// import { truncateText } from '../../utils/utils';
import TruncatedText from "../../utils/TruncatedText";
import { toCamelCase, toSentenceCase } from "../../utils/utils";
import Swal from "sweetalert2";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import "../../fonts/NotoSansDevanagari";
import SatisfactionGauge from "./SatisfactionIndex";
import BarCharts from "../dashboard/BarCharts";
import PieCharts from "../dashboard/PieCharts";
import upDownArrow from "../../assets/images/up-down-arrow.svg";
import { useRef } from "react";
// import CallUI from 'https://sea-lion-app-xp7yb.ondigitalocean.app/feedback';

const GRADIENT_COLORS = ["#FF852B", "#D37929", "#B34700"];

const formatFeedbackCategory = (text) => {
  if (!text) return "";
  return text
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
};

export default function AdminUser({ dashboardData, data, overdueData }) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isAdminModalOpen, setIsAdminModalOpen] = useState(false);
  const [isATROpen, setIsATROpen] = useState(false);
  const [isCommentOpen, setIsCommentOpen] = useState(false);
  const [isFeedbackOpen, setIsFeedbackOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [selectedTableData, setSelectedTableData] = useState(null);
  const [isViewOnly, setIsViewOnly] = useState(false);
  const [showCommentArea, setShowCommentArea] = useState(false);
  const [isLiked, setIsLiked] = useState(false);
  const [comment, setComment] = useState(""); // New state to store comment
  const [adminComment, setAdminComment] = useState(""); // New state to store comment
  const [loading, setLoading] = useState(false);
  const [saveLoading, setSaveLoading] = useState(false);
  const [queryUpdate, setQueryUpdate] = useState(true);
  const [rating, setRating] = useState(true);
  const [pieChartData, setPieChartData] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchParam, setSearchParam] = useState("All");
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: "ascending",
  });
  const tableRef = useRef(null);
  const [atrSummary, setAtrSummary] = useState("");
  const [atrFile, setAtrFile] = useState(null);
  const [atrUploadLoading, setAtrUploadLoading] = useState(false);
  const [atrFileUrl, setAtrFileUrl] = useState("");
  const [audioFile, setAudioFile] = useState(null);
  const [audioUploadLoading, setAudioUploadLoading] = useState(false);
  const [audioSummary, setAudioSummary] = useState("");
  const [audioFileUrl, setAudioFileUrl] = useState("");
  const [response, setResponse] = useState("");

  const calculateDaysLapsed = (row) => {
    if (!row.grievance_submission_timestamp) return 0;
    const submittedDate = new Date(row.grievance_submission_timestamp);
    const date = new Date();
    const diff = date - submittedDate;
    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    if (row.tat === "within 1 day") return days - 1 > 0 ? days - 1 : 0;
    if (row.tat === "2 days") return days - 2 > 0 ? days - 2 : 0;
    if (row.tat === "3 days") return days - 3 > 0 ? days - 3 : 0;
    return 0;
  };

  const requestSort = (key) => {
    let direction = "ascending";
    if (sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending";
    }
    setSortConfig({ key, direction });
  };

  const [deptFilter, setDeptFilter] = useState("All");

  useEffect(() => {
    const getRating = async () => {
      try {
        const res = await axios.get(`${AUTH_URL}api/average_feedback_rating`, {
          headers: { "Content-Type": "application/json" },
        });
        setRating(res.data?.average_feedback_rating);
      } catch (error) {
        console.log("No records");
      }
    };
    getRating();
  }, []);
  // Derive counts and groupings
  const stats = useMemo(() => {
    const normalizeStatus = (status) => {
      const s = (status || "pending").toLowerCase();
      if (s === "pending") return "Pending";
      if (s === "resolved" || s === "closed") return "Resolved";
      if (s === "rejected") return "Rejected";
      if (s === "responded") return "Responded";
      return "Other";
    };

    const statusSummary = [
      {
        name: "Employee/Pensioner of IA&AD",
        value: dashboardData.officer1,
      },
      {
        name: "Grievance pertaining to State Govt. Employees/ Pensioners if pending in PAGs/AGs offices",
        value: dashboardData.officer2,
      },
    ];
    const statusCounts = {};
    const categories = {};
    const grievances = [];

    data.forEach((item) => {
      const normalizedStatus = normalizeStatus(item.status);
      statusCounts[normalizedStatus] =
        (statusCounts[normalizedStatus] || 0) + 1;

      const category = item.llm_subcategory || "Other";
      categories[category] = (categories[category] || 0) + 1;

      grievances.push({
        id: item.grievance_id.slice(0, 6) + "...",
        category,
        status: normalizedStatus,
        date: new Date(item.grievance_submission_timestamp).toLocaleDateString(
          "en-IN",
        ),
      });
    });

    const dueDatadept =
      Array.isArray(overdueData) && overdueData.length
        ? (() => {
          const aggregated = {};
          overdueData.forEach((item) => {
            const normalizedStatus = item.llm_category;
            if (!aggregated[normalizedStatus]) {
              aggregated[normalizedStatus] = {
                name: normalizedStatus,
                count: 0,
              };
            }
            aggregated[normalizedStatus].count += 1;
          });
          return Object.values(aggregated).map((item) => ({
            ...item,
          }));
        })()
        : null;

    const dueDataTat =
      Array.isArray(overdueData) && overdueData.length
        ? (() => {
          const aggregated = {};
          overdueData.forEach((item) => {
            const overdue = calculateDaysLapsed(item);
            let timeOverdue = 0;
            if (overdue >= 0 && overdue <= 1) timeOverdue = "0-1 day";
            if (overdue > 1 && overdue <= 5) timeOverdue = "2-5 days";
            if (overdue > 5 && overdue <= 10) timeOverdue = "6-10 days";
            if (overdue > 10) timeOverdue = "more than 10 days";
            if (!aggregated[timeOverdue]) {
              aggregated[timeOverdue] = { days: timeOverdue, count: 0 };
            }
            aggregated[timeOverdue].count += 1;
          });
          return Object.values(aggregated).map((item) => ({
            ...item,
          }));
        })()
        : null;

    return {
      total: data.length,
      statusPieData:
        statusSummary ??
        Object.entries(statusCounts).map(([name, value]) => ({ name, value })),
      categories: Object.entries(categories).map(([name, value]) => ({
        name,
        value,
      })),
      grievances,
      allGrievances: data,
      overdueGrievances: overdueData,
      dueDatadept,
      dueDataTat,
    };
  }, [data, dashboardData, overdueData]);

  const filteredAdminGrievances = useMemo(() => {
    let filtered = stats.allGrievances;
    filtered = filtered.filter((item) => {
      // Filter only by grievance ID
      return item.officer_name && item.officer_name.toLowerCase() === "admin";
    });

    if (sortConfig.key) {
      filtered = [...filtered].sort((a, b) => {
        let aValue, bValue;

        switch (sortConfig.key) {
          case "grievance_id":
            aValue = a.grievance_id || "";
            bValue = b.grievance_id || "";
            break;
          case "severity":
            aValue = a.severity || "";
            bValue = b.severity || "";
            break;
          case "source":
            aValue = a.source || "";
            bValue = b.source || "";
            break;
          case "reg_date":
            aValue = new Date(a.grievance_submission_timestamp || 0).getTime();
            bValue = new Date(b.grievance_submission_timestamp || 0).getTime();
            break;
          case "tat":
            aValue = a.tat || "";
            bValue = b.tat || "";
            break;
          case "days_lapsed":
            aValue = calculateDaysLapsed(a);
            bValue = calculateDaysLapsed(b);
            break;
          case "feedback_call_summary":
            aValue = a.feedback_call_summary || "";
            bValue = b.feedback_call_summary || "";
            break;
          case "feedback_call_category": {
            const getWeight = (val) => {
              if (!val) return 3;
              const v = val.toLowerCase();
              if (v.includes("very_satisfied") || v.includes("very satisfied"))
                return 1;
              if (
                v.includes("very_unsatisfied") ||
                v.includes("very unsatisfied")
              )
                return 2;
              return 3;
            };
            aValue = getWeight(a.feedback_call_category);
            bValue = getWeight(b.feedback_call_category);
            break;
          }
          default:
            return 0;
        }

        if (aValue < bValue) {
          return sortConfig.direction === "ascending" ? -1 : 1;
        }
        if (aValue > bValue) {
          return sortConfig.direction === "ascending" ? 1 : -1;
        }
        return 0;
      });
    }
    return filtered;
  }, [
    stats.allGrievances,
    stats.overdueGrievances,
    searchQuery,
    searchParam,
    sortConfig,
  ]);

  const filteredGrievances = useMemo(() => {
    let filtered = stats.allGrievances;
    if (searchQuery) {
      const lowerQuery = searchQuery.toLowerCase();
      filtered = filtered.filter((item) => {
        // Filter only by grievance ID
        return (
          item.grievance_id &&
          item.grievance_id.toLowerCase().includes(lowerQuery)
        );
      });
    }

    if (sortConfig.key) {
      filtered = [...filtered].sort((a, b) => {
        let aValue, bValue;

        switch (sortConfig.key) {
          case "grievance_id":
            aValue = a.grievance_id || "";
            bValue = b.grievance_id || "";
            break;
          case "severity":
            aValue = a.severity || "";
            bValue = b.severity || "";
            break;
          case "source":
            aValue = a.source || "";
            bValue = b.source || "";
            break;
          case "reg_date":
            aValue = new Date(a.grievance_submission_timestamp || 0).getTime();
            bValue = new Date(b.grievance_submission_timestamp || 0).getTime();
            break;
          case "tat":
            aValue = a.tat || "";
            bValue = b.tat || "";
            break;
          case "days_lapsed":
            aValue = calculateDaysLapsed(a);
            bValue = calculateDaysLapsed(b);
            break;
          case "feedback_call_summary":
            aValue = a.feedback_call_summary || "";
            bValue = b.feedback_call_summary || "";
            break;
          case "feedback_call_category": {
            const getWeight = (val) => {
              if (!val) return 3;
              const v = val.toLowerCase();
              if (v.includes("very_satisfied") || v.includes("very satisfied"))
                return 1;
              if (
                v.includes("very_unsatisfied") ||
                v.includes("very unsatisfied")
              )
                return 2;
              return 3;
            };
            aValue = getWeight(a.feedback_call_category);
            bValue = getWeight(b.feedback_call_category);
            break;
          }
          default:
            return 0;
        }

        if (aValue < bValue) {
          return sortConfig.direction === "ascending" ? -1 : 1;
        }
        if (aValue > bValue) {
          return sortConfig.direction === "ascending" ? 1 : -1;
        }
        return 0;
      });
    }
    return filtered;
  }, [
    stats.allGrievances,
    stats.overdueGrievances,
    searchQuery,
    searchParam,
    sortConfig,
  ]);

  const filteredDueGrievances = useMemo(() => {
    let result = stats.overdueGrievances || [];
    if (deptFilter !== "All") {
      result = result.filter(
        (item) =>
          item.llm_category.toLowerCase() === deptFilter.toLocaleLowerCase(),
      );
    }

    if (sortConfig.key) {
      result = [...result].sort((a, b) => {
        let aValue, bValue;

        switch (sortConfig.key) {
          case "source":
            aValue = a.source || "";
            bValue = b.source || "";
            break;
          default:
            return 0;
        }

        if (aValue < bValue) {
          return sortConfig.direction === "ascending" ? -1 : 1;
        }
        if (aValue > bValue) {
          return sortConfig.direction === "ascending" ? 1 : -1;
        }
        return 0;
      });
    }

    return result;
  }, [stats.overdueGrievances, deptFilter, sortConfig]);

  const filteredSelectedGrievances = useMemo(() => {
    let result = selectedTableData || [];
    if (deptFilter !== "All") {
      result = result.filter(
        (item) => item.llm_category.toLowerCase() === deptFilter.toLowerCase(),
      );
    }
    if (sortConfig.key) {
      result = [...result].sort((a, b) => {
        let aValue, bValue;

        switch (sortConfig.key) {
          case "source":
            aValue = a.source || "";
            bValue = b.source || "";
            break;
          default:
            return 0;
        }

        if (aValue < bValue) {
          return sortConfig.direction === "ascending" ? -1 : 1;
        }
        if (aValue > bValue) {
          return sortConfig.direction === "ascending" ? 1 : -1;
        }
        return 0;
      });
    }
    return result;
  }, [selectedTableData, deptFilter, sortConfig]);

  // Fetch pie chart percentages from the new API
  useEffect(() => {
    const fetchPieChartData = async () => {
      try {
        if (data && data.length > 0) {
          const userId = data[0].user_id;
          if (userId) {
            const res = await axios.get(
              `${AUTH_URL}api/pendingrespondedpercentageuser?user_id=${userId}`,
            );
            if (res.data && res.data.success) {
              setPieChartData({
                pending: {
                  count: res.data.pending_count,
                  percentage: res.data.pending_percentage,
                },
                responded: {
                  count: res.data.responded_count,
                  percentage: res.data.responded_percentage,
                },
                total: res.data.total_grievances,
              });
            }
          }
        }
      } catch (error) {
        console.error("Error fetching pie chart data:", error);
      }
    };

    fetchPieChartData();
  }, [data]);
  const handleEditClick = (item) => {
    setSelectedRow(item);
    setIsViewOnly(false); // Set view-only mode
    setIsAdminModalOpen(true);
  };
  const handleAdminViewClick = async (item) => {
    const res = await getGrievance(item.grievance_id);
    if (res) {
      setSelectedRow(res);
      setIsViewOnly(true); // Set view-only mode
      setIsAdminModalOpen(true);
    }
  };

  const handleViewClick = async (item) => {
    const res = await getGrievance(item.grievance_id);
    if (res) {
      setSelectedRow(res);
      setIsViewOnly(true); // Set view-only mode
      setIsModalOpen(true);
    }
  };
  const handleViewATR = (item) => {
    setSelectedRow(item);
    setIsViewOnly(true); // Set view-only mode
    setIsATROpen(true);
  };

  const handleCloseATR = () => {
    setIsATROpen(false);
    setSelectedRow(null);
  };
  const handleViewFeedback = (item) => {
    setSelectedRow(item);
    setIsViewOnly(true); // Set view-only mode
    setIsFeedbackOpen(true);
  };

  const handleCloseFeedback = () => {
    setIsFeedbackOpen(false);
    setSelectedRow(null);
  };

  const handleCloseComment = () => {
    setIsCommentOpen(false);
    setSelectedRow(null);
  };
  const handleClose = () => {
    setIsModalOpen(false);
    setSelectedRow(null);
  };
  const handleLikeClick = (e) => {
    e.preventDefault();
    setIsLiked(true);
    setShowCommentArea(false); // Hide comment area after liking
  };

  const handleDislikeClick = (e) => {
    e.preventDefault();
    setIsLiked(false);
    setShowCommentArea(true); // Show comment area after disliking
  };

  const handleSave1 = async () => {
    setSaveLoading(true);
    try {
      const feedbackData = {
        grievance_id: selectedRow.id, // Assuming you have selectedRow.id for grievance ID
        feedbackrating: isLiked ? 1 : 0, // 1 for like, 0 for dislike
        feedbacktext: comment, // The comment entered by the user
      };

      const res = await axios(`${AUTH_URL}/api/feedback`, feedbackData, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (res.status === 200) {
        console.log("Feedback saved successfully");
        // Optionally, reset the states after saving
        setIsLiked(false);
        setComment("");
        setShowCommentArea(false);
      }
    } catch (error) {
      console.error("Error saving feedback:", error);
    } finally {
      setSaveLoading(false);
    }
  };
  const handleViewComment = (item) => {
    setSelectedRow(item);
    setIsViewOnly(true); // Set view-only mode
    setIsCommentOpen(true);
  };

  const handleEditComment = (item) => {
    setSelectedRow(item);
    setIsViewOnly(false); // Set view-only mode
    setIsCommentOpen(true);
  };

  const handleNotifyOfficer = async (item) => {
    try {
      const response = await axios.put(
        `${API_URL}api/admin_sendnotification_officer`,
        {
          officer_name: item.officer_name,
          grievance_id: item.grievance_id,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      if (response) {
        // alert("Notification sent to Officer: " + toSentenceCase(item.officer))
        Swal.fire({
          title: "Success",
          text: `Reminder has been sent successfully to Officer : ${toSentenceCase(item.officer)}`,
          icon: "success",
        });
      }
    } catch (error) {
      if (error.response) {
        // alert(error.response.data.message);
        Swal.fire({
          title: "Success",
          text: `${error.response.data.message}`,
          icon: "success",
        });
      } else {
        alert("We are facing issue at our end. Please try after some time.");
      }
    }
  };

  const saveAdminComment = async () => {
    try {
      const payload = {
        grievance_id: selectedRow.grievance_id,
        admincomment: adminComment,
      };

      let res = await axios.post(`${AUTH_URL}api/admin_comment`, payload, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (res.status === 200) {
        setQueryUpdate(true);
        setIsModalOpen(false);
        Swal.fire({
          title: "Feedback Saved!",
          text: "Feedback document has been saved successfully.",
          icon: "success",
        });
      }
    } catch (error) {
      console.log("Error in Update Query API", error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: `${error?.response?.data?.error || "Error in Update Query API"}`,
      });
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setSelectedRow((prevState) => ({
      ...prevState,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const downloadPDF = () => {
    const doc = new jsPDF("landscape");

    // IMPORTANT
    doc.setFont("NotoSansDevanagari");

    // Table columns
    const columns = [
      { header: "Grievance ID", dataKey: "grievance_id" },
      { header: "User Query", dataKey: "user_query" },
      { header: "Department", dataKey: "llm_ministry" },
      { header: "Status", dataKey: "status" },
      { header: "Officer Response", dataKey: "grievance_response" },
      { header: "ATR", dataKey: "atr_summary" },
      { header: "Feedback Call", dataKey: "feedback_call_summary" },
      {
        header: "User Feedback ",
        dataKey: "user_feedback",
      },
    ];

    // Table rows
    const rows = data.map((item) => ({
      grievance_id: item.grievance_id || "",
      user_query: item.user_query || item.user_query_english || "",

      llm_ministry: item.llm_ministry || "",

      status: item.officer_grievance_status || "",

      grievance_response: item.grievance_response || "",

      atr_summary: item.atr_summary || "",

      feedback_call_summary: item.feedback_call_summary || "",

      user_feedback: item.user_grievance_feedback_comments || "",
    }));

    doc.setFontSize(16);

    doc.text("Grievance Report", 14, 15);

    autoTable(doc, {
      startY: 25,

      columns,

      body: rows,

      theme: "grid",

      styles: {
        font: "NotoSansDevanagari",
        fontSize: 7,
        overflow: "linebreak",
        cellPadding: 2,
        valign: "middle",
        halign: "left",
      },

      headStyles: {
        fillColor: [41, 128, 185],
        font: "NotoSansDevanagari",
        fontStyle: "normal",
        textColor: [255, 255, 255],
        fontSize: 8,
      },

      alternateRowStyles: {
        fillColor: [245, 245, 245],
      },

      columnStyles: {
        grievance_id: {
          cellWidth: 25,
        },

        user_query: {
          cellWidth: 20,
        },

        llm_ministry: {
          cellWidth: 20,
        },

        status: {
          cellWidth: 20,
        },

        grievance_response: {
          cellWidth: 20,
        },

        atr_summary: {
          cellWidth: 70,
        },

        atr_category: {
          cellWidth: 15,
        },

        feedback_call_summary: {
          cellWidth: 70,
        },

        feedback_call_category: {
          cellWidth: 20,
        },
      },

      margin: {
        top: 20,
        left: 5,
        right: 5,
      },

      didDrawPage: () => {
        doc.setFontSize(10);

        doc.text(`Generated On: ${new Date().toLocaleString()}`, 220, 10);
      },
    });

    doc.save("grievance-report.pdf");
  };

  const handleBarClick = (data) => {
    if (data.name) {
      const selectedDueData = overdueData.filter(
        (item) => item.officer_name === data.name,
      );
      setSelectedTableData(selectedDueData);
    }
    if (data.days) {
      const selectedDueData = overdueData.filter((item) => {
        const overdue = calculateDaysLapsed(item);
        let timeOverdue = 0;
        if (overdue >= 0 && overdue <= 1) timeOverdue = "0-1 day";
        if (overdue > 1 && overdue <= 5) timeOverdue = "2-5 days";
        if (overdue > 5 && overdue <= 10) timeOverdue = "6-10 days";
        if (overdue > 10) timeOverdue = "more than 10 days";
        return timeOverdue === data.days;
      });
      setSelectedTableData(selectedDueData);
    }
    setTimeout(() => {
      tableRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }, 100);
  };
  const FILE_URL_SEPARATOR = "|||FILE_URL|||";

  const decodeSummary = (raw) => {
    if (!raw) return { summary: "", fileUrl: "" };
    const parts = raw.split(FILE_URL_SEPARATOR);
    return { summary: parts[0], fileUrl: parts[1] || "" };
  };
  const handleAtrUpload = async () => {
    if (!atrFile) {
      Swal.fire("Error", "Please select a file to upload", "error");
      return;
    }
    const formData = new FormData();
    formData.append("uploaded_file", atrFile);

    try {
      setAtrUploadLoading(true);
      const res = await axios.post(
        `${CHAT_URL}v1/categorize_atr_file`,
        formData,
        {
          headers: {
            accept: "application/json",
            "x-source": "12",
            "x-consumer-id": "12",
            "Content-Type": "multipart/form-data",
          },
        },
      );

      if (res.status === 200 && res.data) {
        setAtrSummary(res.data.summary);
        setAtrFileUrl(res.data.file_url);
        Swal.fire({
          title: "Success!",
          text: "ATR Document uploaded and analyzed successfully.",
          icon: "success",
        });
      }
    } catch (error) {
      console.log("Error uploading ATR:", error);
      Swal.fire({
        icon: "error",
        title: "Upload Failed",
        text: "Could not upload the ATR document.",
      });
    } finally {
      setAtrUploadLoading(false);
    }
  };
  const handleATR = async (grievanceId) => {
    // Get file URL from state (fresh upload) or from persisted summary
    const fileUrl =
      atrFileUrl ||
      decodeSummary(selectedRow?.atr_summary).fileUrl ||
      selectedRow?.atr_file_url;
    if (!fileUrl) {
      Swal.fire({
        icon: "info",
        title: "No ATR File",
        text: "No ATR file URL is available for download.",
      });
      return;
    }

    try {
      window.open(fileUrl, "_blank");
    } catch (error) {
      console.log("Error downloading ATR:", error);
      Swal.fire({
        icon: "error",
        title: "Download Failed",
        text: "Could not download the ATR document.",
      });
    }
  };

  const handleAudioUpload = async () => {
    if (!audioFile) {
      Swal.fire("Error", "Please select an audio file to upload", "error");
      return;
    }
    const formData = new FormData();
    formData.append("uploaded_file", audioFile);

    try {
      setAudioUploadLoading(true);
      const res = await axios.post(`${CHAT_URL}v1/upload_file`, formData, {
        headers: {
          accept: "application/json",
          "x-source": "787",
          "x-consumer-id": "878",
          "Content-Type": "multipart/form-data",
        },
      });

      if (res.status === 200 && res.data) {
        setAudioSummary(res.data.summary);
        setAudioFileUrl(res.data.file_url);
        setResponse(res.data.response);
        Swal.fire({
          title: "Success!",
          text: "Audio file uploaded and analyzed successfully.",
          icon: "success",
        });
      }
    } catch (error) {
      console.log("Error uploading audio:", error);
      Swal.fire({
        icon: "error",
        title: "Upload Failed",
        text: "Could not upload the audio file.",
      });
    } finally {
      setAudioUploadLoading(false);
    }
  };

  const encodeSummaryWithUrl = (summary, fileUrl) => {
    if (!fileUrl) return summary;
    return `${summary}${FILE_URL_SEPARATOR}${fileUrl}`;
  };

  const handleSave = async () => {
    try {
      setLoading(true);

      const isAlreadyResponded =
        selectedRow?.officer_grievance_status?.toLowerCase() !== "add comment";

      if (isAlreadyResponded) {
        let summaryToSave = "";
        let urlToSave = "";
        let url = "";
        let payload = null;
        // If already responded, we are just saving the ATR via update_atr
        if (!selectedRow.atr_uploaded) {
          summaryToSave =
            atrSummary || decodeSummary(selectedRow.atr_summary).summary;
          urlToSave =
            atrFileUrl || decodeSummary(selectedRow.atr_summary).fileUrl;
          url = "update_atr";
          payload = {
            query_id: selectedRow._id,
            summary: encodeSummaryWithUrl(summaryToSave, urlToSave),
            status: "Resolved",
          };
        } else {
          summaryToSave =
            audioSummary ||
            decodeSummary(selectedRow.feedback_call_summary).summary;
          urlToSave =
            audioFileUrl || decodeSummary(selectedRow.atr_summary).summary;
          url = "update_feedback";
          payload = {
            query_id: selectedRow._id,
            summary: encodeSummaryWithUrl(summaryToSave, urlToSave),
            feedback: response,
          };
        }

        let res = await axios.put(`${AUTH_URL}api/${url}`, payload, {
          headers: {
            "Content-Type": "application/json",
          },
        });

        if (res.status === 200) {
          setQueryUpdate(true);
          setIsModalOpen(false);
          setAtrFile(null);
          setAtrSummary("");
          setAtrFileUrl("");
          if (url === "update_feedback") {
            Swal.fire({
              title: "Audio Saved!",
              text: "Audio document has been saved successfully.",
              icon: "success",
            });
          } else {
            Swal.fire({
              title: "ATR Saved!",
              text: "ATR document has been saved successfully.",
              icon: "success",
            });
          }
        }
      } else {
        // Normal response save for pending grievances
        const comments =
          selectedRow.officer_grievance_comments ||
          selectedRow.grievance_response ||
          "";
        const isResponded = comments.trim().length > 0;

        const payload = {
          query_id: selectedRow._id,
          officer_grievance_comments: comments,
          atr_uploaded: false,
        };

        if (isResponded) {
          payload.status = "Responded";
        }

        let res = await axios.put(
          `${AUTH_URL}api/grievance_response`,
          payload,
          {
            headers: {
              "Content-Type": "application/json",
            },
          },
        );
        if (res.status === 200) {
          setQueryUpdate(true);
          setIsModalOpen(false);
          setAtrFile(null);
          setAtrSummary("");
          setAtrFileUrl("");
          Swal.fire({
            title: "Query Updated!",
            text: "You have successfully updated.",
            icon: "success",
          });
        }
      }
    } catch (error) {
      console.log("Error in Update Query API", error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: `${error?.response?.data?.error || "Error in Update Query API"}`,
      });
    } finally {
      setLoading(false);
      setIsAdminModalOpen(false);
    }
  };

  return (
    <div className="p-6 bg-gray-100 min-h-screen font-sans">
      {/* Charts Section */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 my-6">
        <div className="bg-white shadow rounded-xl p-4 w-full h-[400px]  border border-[#6DB5BC]">
          <PieCharts
            data={stats.statusPieData}
            nameKey="name"
            title="Grievance By Categories"
            innerRadius="45%"
            xAxisName="Number of Grievances"
            colors={[
              "#3B82C4",
              "#2FA7A0",
              "#D79A4A",
              "#8A6CCF",
              "#D07A5C",
              "#5DADE2",
            ]}
          />
        </div>

        <div className="bg-white shadow rounded-xl p-4 w-full h-[400px]  border border-[#6DB5BC]">
          <BarCharts
            data={dashboardData.summary}
            nameKey="name"
            title="Top Sub-Categories of Grievances"
            xAxisName="Number of Grievances"
            colors={[
              "#3B82C4",
              "#2FA7A0",
              "#D79A4A",
              "#8A6CCF",
              "#D07A5C",
              "#5DADE2",
            ]}
          />
        </div>
        {
          stats.dueDatadept && (
            <div className="bg-white shadow rounded-xl p-4 w-full h-[400px]  border border-[#6DB5BC]">
              <PieCharts
                data={stats.dueDatadept}
                nameKey="name"
                dataKey="count"
                title="Overdue Grievances by Categories"
                innerRadius="45%"
                xAxisName="Number of Grievances"
                colors={[
                  "#3B82C4",
                  "#2FA7A0",
                  "#D79A4A",
                  "#8A6CCF",
                  "#D07A5C",
                  "#5DADE2",
                ]}
                onBarClick={handleBarClick}
              />
            </div>
          )
          // <div className='bg-white shadow rounded-xl p-4 w-full h-[400px]  border border-[#6DB5BC]'>
          //   <BarCharts
          //     data={stats.dueDatadept}
          //     nameKey="name"
          //     title="Overdue Grievances by Categories"
          //     xAxisName="Category"
          //     colors={["#6366F1", "#10B981", "#F59E0B", "#EC4899", "#8B5CF6"]}
          //     onBarClick={handleBarClick}
          //   />
          // </div>
        }
        {stats.dueDataTat && (
          <div className="bg-white shadow rounded-xl p-4 w-full h-[400px]  border border-[#6DB5BC]">
            <BarCharts
              data={stats.dueDataTat}
              nameKey="days"
              title="Grievances by Overdue Days"
              xAxisHeight={35}
              xAxisName="Number of Days"
              colors={[
                "#3B82C4",
                "#2FA7A0",
                "#D79A4A",
                "#8A6CCF",
                "#D07A5C",
                "#5DADE2",
              ]}
              onBarClick={handleBarClick}
            />
          </div>
        )}
      </div>
      {selectedTableData && (
        <div
          className="bg-white p-6 w-full overflow-hidden flex flex-col  border border-[#6DB5BC] rounded-xl"
          ref={tableRef}
        >
          <p className="text-lg font-semibold text-gray-800 mb-4">
            Overdue Grievances
          </p>
          <div className="overflow-x-auto">
            <table className="min-w-full text-sm text-center border border-gray-200 rounded-lg">
              <thead className="bg-gray-100 text-gray-700">
                <tr>
                  <th className="py-3 px-2 border-b">S. No.</th>
                  <th className="py-3 px-2 border-b">Grievance ID</th>
                  <th
                    className="py-3 px-2 border-b cursor-pointer hover:bg-gray-200"
                    onClick={() => requestSort("source")}
                  >
                    <div className="flex items-center justify-center gap-1">
                      Source{" "}
                      <img src={upDownArrow} alt="sort" className="w-3 h-3" />
                    </div>
                  </th>
                  <th className="py-3 px-2 border-b">User Grievance</th>
                  <th className="py-3 px-2 border-b flex flex-col items-center gap-1">
                    <span>Department</span>
                    <select
                      id="statusFilter"
                      value={deptFilter}
                      onChange={(e) => setDeptFilter(e.target.value)}
                      className="border border-gray-300 rounded-lg px-2 py-1 text-xs focus:outline-none focus:ring focus:ring-indigo-200 w-[100px]"
                    >
                      <option value="All">All</option>
                      <option value="Employee/Pensioner of IA&AD">
                        Employee/Pensioner of IA&AD
                      </option>
                      <option value="Grievance pertaining to State Govt. Employees/ Pensioners if pending in PAGs/AGs offices">
                        Grievance pertaining to State Govt. Employees/
                        Pensioners if pending in PAGs/AGs offices
                      </option>
                    </select>
                  </th>
                  <th className="py-3 px-2 border-b">Officer</th>
                  <th className="py-3 px-2 border-b">Days Overdue</th>
                  <th className="py-3 px-2 border-b w-[50px]">Send Reminder</th>
                </tr>
              </thead>
              <tbody>
                {filteredSelectedGrievances.map((row, idx) => (
                  <tr
                    key={idx}
                    className="border-b hover:bg-gray-50 transition"
                  >
                    <td className="py-2 px-2">{idx + 1}</td>
                    <td
                      className="py-2 px-2 font-mono font-bold text-indigo-600 cursor-pointer"
                      onClick={() => handleViewClick(row)}
                    >
                      <TruncatedText text={row.grievance_id || ""} limit={6} />
                    </td>
                    <td className="py-2 px-4 text-gray-800">
                      <TruncatedText text={row.source || "CAG"} limit={20} />
                    </td>
                    <td className="py-2 px-2 text-gray-800">
                      <TruncatedText text={row.user_query || ""} limit={20} />
                    </td>
                    <td className="py-2 px-2 text-gray-800">
                      <TruncatedText text={row.llm_category || ""} limit={20} />
                    </td>
                    <td className="py-2 px-2 text-gray-800">
                      <TruncatedText
                        text={toSentenceCase(
                          row.officer ||
                          (row.officer_name?.toLowerCase() === "admin"
                            ? "Admin"
                            : ""),
                        )}
                        limit={20}
                      />
                    </td>

                    <td className="py-2 px-4 text-gray-600">
                      {calculateDaysLapsed(row)}
                    </td>

                    <td className="py-2 px-2 text-center">
                      {row.officer_grievance_status?.toLowerCase() !==
                        "resolved" && (
                          <button
                            className="py-2 px-2 bg-blue-500 text-white rounded hover:bg-blue-600"
                            onClick={() => handleNotifyOfficer(row)}
                          >
                            Remind
                          </button>
                        )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      <div className="flex flex-col md:flex-row justify-between h-auto md:h-[50vh] my-6 gap-4">
        <div className="w-full md:w-[28%] border border-[#6DB5BC] rounded-xl bg-white">
          <SatisfactionGauge value={rating} />
        </div>
        <div className="bg-white p-6 w-full md:w-[70%] overflow-hidden flex flex-col  border border-[#6DB5BC] rounded-xl">
          <p className="text-lg font-semibold text-gray-800 mb-4">
            All Overdue Grievances
          </p>
          <div className="overflow-x-auto">
            <table className="min-w-full text-sm text-left border border-gray-200 rounded-lg">
              <thead className="bg-gray-100 text-gray-700">
                <tr>
                  <th className="py-3 px-2 border-b">S. No.</th>
                  <th className="py-3 px-2 border-b">Grievance ID</th>
                  <th
                    className="py-3 px-2 border-b cursor-pointer hover:bg-gray-200"
                    onClick={() => requestSort("source")}
                  >
                    <div className="flex items-center justify-center gap-1">
                      Source{" "}
                      <img src={upDownArrow} alt="sort" className="w-3 h-3" />
                    </div>
                  </th>
                  <th className="py-3 px-2 border-b">User Grievance</th>
                  <th className="py-3 px-2 border-b flex flex-col gap-1">
                    <span>Department</span>
                    <select
                      id="statusFilter"
                      value={deptFilter}
                      onChange={(e) => setDeptFilter(e.target.value)}
                      className="border border-gray-300 rounded-lg px-2 py-1 text-xs focus:outline-none focus:ring focus:ring-indigo-200 w-[100px]"
                    >
                      <option value="All">All</option>
                      <option value="Employee/Pensioner of IA&AD">
                        Employee/Pensioner of IA&AD
                      </option>
                      <option value="Grievance pertaining to State Govt. Employees/ Pensioners if pending in PAGs/AGs offices">
                        Grievance pertaining to State Govt. Employees/
                        Pensioners if pending in PAGs/AGs offices
                      </option>
                    </select>
                  </th>
                  <th className="py-3 px-2 border-b">Officer</th>
                  <th className="py-3 px-2 border-b">Days Overdue</th>
                  <th className="py-3 px-2 border-b w-[50px]">Send Reminder</th>
                </tr>
              </thead>
              <tbody>
                {filteredDueGrievances.map((row, idx) => (
                  <tr
                    key={idx}
                    className="border-b hover:bg-gray-50 transition"
                  >
                    <td className="py-2 px-2">{idx + 1}</td>
                    <td
                      className="py-2 px-2 font-mono font-bold text-indigo-600 cursor-pointer"
                      onClick={() => handleViewClick(row)}
                    >
                      <TruncatedText text={row.grievance_id || ""} limit={6} />
                    </td>
                    <td className="py-2 px-4 text-gray-800">
                      <TruncatedText text={row.source || "CAG"} limit={20} />
                    </td>
                    <td className="py-2 px-2 text-gray-800">
                      <TruncatedText text={row.user_query || ""} limit={20} />
                    </td>
                    <td className="py-2 px-2 text-gray-800">
                      <TruncatedText text={row.llm_category || ""} limit={20} />
                    </td>
                    <td className="py-2 px-2 text-gray-800">
                      <TruncatedText
                        text={toSentenceCase(
                          row.officer ||
                          (row.officer_name?.toLowerCase() === "admin"
                            ? "Admin"
                            : ""),
                        )}
                        limit={20}
                      />
                    </td>

                    <td className="py-2 px-4 text-gray-600">
                      {calculateDaysLapsed(row)}
                    </td>

                    <td className="py-2 px-2 text-center">
                      {row.officer_grievance_status?.toLowerCase() !==
                        "resolved" && (
                          <button
                            className="py-2 px-2 bg-blue-500 text-white rounded hover:bg-blue-600"
                            onClick={() => handleNotifyOfficer(row)}
                          >
                            Remind
                          </button>
                        )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      {/* Summary Boxes */}
      {/* <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
        <div className="bg-indigo-600 text-white rounded-2xl p-6 flex justify-between items-center shadow-lg hover:scale-[1.02] transition-transform duration-200 ease-in-out">
          <div>
            <p className="text-sm font-medium text-indigo-100 mb-1">Total User Queries Registered</p>
            <p className="text-4xl font-extrabold tracking-tight">{stats.total}</p>
          </div>
          <div className="bg-indigo-500 p-3 rounded-full">
            <HelpOutlineIcon fontSize="large" className="text-white" />
          </div>
        </div>

        <div className="bg-amber-500 text-white rounded-2xl p-6 flex justify-between items-center shadow-lg hover:scale-[1.02] transition-transform duration-200 ease-in-out">
          <div>
            <p className="text-sm font-medium text-yellow-100 mb-1">Number of User Queries Pending</p>
            <p className="text-4xl font-extrabold tracking-tight">{stats.statusPieData.find(s => s.name === 'Pending')?.value || 0}</p>
          </div>
          <div className="bg-amber-400 p-3 rounded-full">
            <HourglassTopIcon fontSize="large" className="text-white" />
          </div>
        </div>

        <div className="bg-emerald-600 text-white rounded-2xl p-6 flex justify-between items-center shadow-lg hover:scale-[1.02] transition-transform duration-200 ease-in-out">
          <div>
            <p className="text-sm font-medium text-emerald-100 mb-1">Number of User Queries Closed</p>
            <p className="text-4xl font-extrabold tracking-tight">{stats.statusPieData.find(s => s.name === 'Resolved' || s.name === 'Responded')?.value || 0}</p>
          </div>
          <div className="bg-emerald-500 p-3 rounded-full">
            <CheckCircleOutlineIcon fontSize="large" className="text-white" />
          </div>
        </div>
      </div> */}
      <div className="bg-white p-6 w-full mb-6 mt-6 border border-[#6DB5BC] rounded-xl ">
        <p className="text-lg font-semibold text-gray-800 mb-4">
          Escalated Grievances
        </p>
        <div className="flex items-center gap-4 mb-4">
          <input
            type="text"
            placeholder={`Search by Grievance ID...`}
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring focus:ring-indigo-200 w-full sm:w-72"
          />
        </div>
        <div className="overflow-x-auto rounded-lg">
          <table className="min-w-full text-sm text-left border border-gray-200 rounded-lg overflow-hidden">
            <thead className="bg-gray-100 text-gray-700">
              <tr>
                <th className="py-3 px-4 border-b">S. No.</th>
                <th
                  className="py-3 px-4 border-b cursor-pointer hover:bg-gray-200"
                  onClick={() => requestSort("grievance_id")}
                >
                  <div className="flex items-center gap-1">
                    Grievance ID{" "}
                    <img
                      src={upDownArrow}
                      alt="sort"
                      className="w-3 h-3 inline"
                    />
                  </div>
                </th>
                <th
                  className="py-3 px-2 border-b cursor-pointer hover:bg-gray-200"
                  onClick={() => requestSort("source")}
                >
                  <div className="flex items-center justify-center gap-1">
                    Source{" "}
                    <img src={upDownArrow} alt="sort" className="w-3 h-3" />
                  </div>
                </th>
                <th className="py-3 px-4 border-b">User Grievance</th>
                <th className="py-3 px-4 border-b">Department</th>
                <th className="py-3 px-4 border-b">Status</th>
                <th
                  className="py-3 px-4 border-b cursor-pointer hover:bg-gray-200"
                  onClick={() => requestSort("severity")}
                >
                  <div className="flex items-center gap-1">
                    Severity{" "}
                    <img
                      src={upDownArrow}
                      alt="sort"
                      className="w-3 h-3 inline"
                    />
                  </div>
                </th>
                <th
                  className="py-3 px-4 border-b cursor-pointer hover:bg-gray-200"
                  onClick={() => requestSort("reg_date")}
                >
                  <div className="flex items-center gap-1">
                    Reg. Date{" "}
                    <img
                      src={upDownArrow}
                      alt="sort"
                      className="w-3 h-3 inline"
                    />
                  </div>
                </th>
                <th
                  className="py-3 px-2 border-b cursor-pointer hover:bg-gray-200"
                  onClick={() => requestSort("days_lapsed")}
                >
                  <div className="flex items-center justify-center gap-1">
                    Days Overdue{" "}
                    <img src={upDownArrow} alt="sort" className="w-3 h-3" />
                  </div>
                </th>
                <th
                  className="py-3 px-4 border-b cursor-pointer hover:bg-gray-200"
                  onClick={() => requestSort("tat")}
                >
                  <div className="flex items-center gap-1">
                    TAT{" "}
                    <img
                      src={upDownArrow}
                      alt="sort"
                      className="w-3 h-3 inline"
                    />
                  </div>
                </th>
                <th className="py-3 px-4 border-b text-center">Action</th>
              </tr>
            </thead>
            <tbody>
              {filteredAdminGrievances.map((row, idx) => (
                <tr key={idx} className="border-b hover:bg-gray-50 transition">
                  <td className="py-2 px-4">{idx + 1}</td>
                  <td className="py-2 px-4 font-mono text-indigo-600">
                    <TruncatedText text={row.grievance_id} limit={6} />
                  </td>
                  <td className="py-2 px-4 text-gray-800">
                    <TruncatedText text={row.source || "CAG"} limit={20} />
                  </td>
                  <td className="py-2 px-4 text-gray-800">
                    <TruncatedText text={row.user_query} limit={20} />
                  </td>
                  <td className="py-2 px-4">
                    <TruncatedText
                      text={`${row.llm_category} (${row.llm_subcategory})`}
                      limit={20}
                    />
                  </td>
                  <td className="py-2 px-4">
                    <span
                      className={`min-w-[100px] inline-block text-center px-3 py-1 text-xs font-medium rounded-full
      ${row.officer_grievance_status?.toLowerCase() === "resolved"
                          ? "bg-green-600 text-white" // dark yellow
                          : "bg-yellow-600 text-white" // fallback
                        }
    `}
                    >
                      {toSentenceCase(row.officer_grievance_status || "")}
                    </span>
                  </td>
                  <td
                    className={`py-2 px-2 font-medium ${row.severity?.toLowerCase() === "critical" ||
                        row.severity?.toLowerCase() === "high"
                        ? "text-red-600"
                        : row.severity?.toLowerCase() === "semi-critical" ||
                          row.severity?.toLowerCase() === "medium"
                          ? "text-yellow-600"
                          : "text-gray-800"
                      }`}
                  >
                    <TruncatedText text={row.severity || ""} limit={20} />
                  </td>
                  <td className="py-2 px-4 text-gray-600">
                    {new Date(
                      row.grievance_submission_timestamp,
                    ).toLocaleDateString("en-IN")}
                  </td>
                  <td className="py-2 px-4 text-gray-600">
                    {calculateDaysLapsed(row)}
                    {/* {new Date(row.grievance_submission_timestamp).toLocaleDateString('en-IN')} */}
                  </td>
                  <td className="py-2 px-2 text-gray-800">
                    <TruncatedText text={row.tat || ""} limit={20} />
                  </td>

                  <td className="py-2 px-4 text-center">
                    <div className="flex justify-center items-center gap-2">
                      {row.officer_grievance_status?.toLowerCase() !==
                        "pending" ? (
                        <VisibilityIcon
                          fontSize="small"
                          className={`
    cursor-pointer
    ${row.officer_grievance_status?.toLowerCase() === "resolved"
                              ? "text-green-600 hover:text-green-700"
                              : "text-yellow-600 hover:text-yellow-700"
                            }
  `}
                          onClick={() => handleAdminViewClick(row)}
                        />
                      ) : (
                        <EditIcon
                          fontSize="small"
                          className={`
    cursor-pointer
    ${row.officer_grievance_status?.toLowerCase() === "pending"
                              ? "text-yellow-600 hover:text-yellow-700"
                              : row.officer_grievance_status?.toLowerCase() === "responded"
                                ? "text-green-600 hover:text-green-700"
                                : "text-black hover:text-gray-800"
                            }
  `}
                          onClick={() => handleEditClick(row)}
                        />
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      <div className="bg-white p-6 w-full flex flex-col  border border-[#6DB5BC] rounded-xl">
        <p className="text-lg font-semibold text-gray-800 mb-4">
          Grievances Over Time
        </p>
        <div className="flex items-center gap-4 mb-4">
          {/* 
            <select
              value={searchParam}
              onChange={(e) => setSearchParam(e.target.value)}
              className="border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring focus:ring-indigo-200 bg-white"
            >
              <option value="All">All Parameters</option>
              <option value="Grievance ID">Grievance ID</option>
              <option value="User Query">User Query</option>
              <option value="Department">Department</option>
              <option value="Status">Status</option>
              <option value="Reg. Date">Reg. Date</option>
              <option value="Days Lapsed">Days Lapsed</option>
            </select>
            */}
          <input
            type="text"
            placeholder={`Search by Grievance ID...`}
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring focus:ring-indigo-200 w-full sm:w-72"
          />
        </div>
        <div className="overflow-x-auto rounded-lg">
          <table className="min-w-full text-sm text-left border border-gray-200 ">
            <thead className="bg-gray-100 text-gray-700 text-center">
              <tr>
                <th className="py-3 px-2 border-b">S. No.</th>
                <th
                  className="py-3 px-2 border-b cursor-pointer hover:bg-gray-200"
                  onClick={() => requestSort("grievance_id")}
                >
                  <div className="flex items-center justify-center gap-1">
                    Grievance ID{" "}
                    <img src={upDownArrow} alt="sort" className="w-3 h-3" />
                  </div>
                </th>
                <th
                  className="py-3 px-2 border-b cursor-pointer hover:bg-gray-200"
                  onClick={() => requestSort("source")}
                >
                  <div className="flex items-center justify-center gap-1">
                    Source{" "}
                    <img src={upDownArrow} alt="sort" className="w-3 h-3" />
                  </div>
                </th>
                <th className="py-3 px-2 border-b">User Grievance</th>
                <th className="py-3 px-2 border-b">Department</th>
                <th className="py-3 px-2 border-b">Status</th>
                <th className="py-3 px-2 border-b">Officer Response</th>
                <th className="py-3 px-2 border-b">ATR</th>
                <th
                  className="py-3 px-2 border-b cursor-pointer hover:bg-gray-200"
                  onClick={() => requestSort("feedback_call_summary")}
                >
                  <div className="flex items-center justify-center gap-1">
                    Feedback Call{" "}
                    <img src={upDownArrow} alt="sort" className="w-3 h-3" />
                  </div>
                </th>
                <th
                  className="py-3 px-2 border-b cursor-pointer hover:bg-gray-200"
                  onClick={() => requestSort("feedback_call_category")}
                >
                  <div className="flex items-center justify-center gap-1">
                    Feedback Call Category{" "}
                    <img src={upDownArrow} alt="sort" className="w-3 h-3" />
                  </div>
                </th>
                <th
                  className="py-3 px-2 border-b cursor-pointer hover:bg-gray-200"
                  onClick={() => requestSort("severity")}
                >
                  <div className="flex items-center justify-center gap-1">
                    Severity{" "}
                    <img src={upDownArrow} alt="sort" className="w-3 h-3" />
                  </div>
                </th>
                <th
                  className="py-3 px-2 border-b cursor-pointer hover:bg-gray-200"
                  onClick={() => requestSort("reg_date")}
                >
                  <div className="flex items-center justify-center gap-1">
                    Reg. Date{" "}
                    <img src={upDownArrow} alt="sort" className="w-3 h-3" />
                  </div>
                </th>
                <th
                  className="py-3 px-2 border-b cursor-pointer hover:bg-gray-200"
                  onClick={() => requestSort("tat")}
                >
                  <div className="flex items-center justify-center gap-1">
                    TAT <img src={upDownArrow} alt="sort" className="w-3 h-3" />
                  </div>
                </th>
                <th
                  className="py-3 px-2 border-b cursor-pointer hover:bg-gray-200"
                  onClick={() => requestSort("days_lapsed")}
                >
                  <div className="flex items-center justify-center gap-1">
                    Days Overdue{" "}
                    <img src={upDownArrow} alt="sort" className="w-3 h-3" />
                  </div>
                </th>
                <th className="py-3 px-2 border-b">Admin Comment</th>
                <th className="py-3 px-2 border-b">Send Reminder</th>
              </tr>
            </thead>
            <tbody>
              {filteredGrievances.map((row, idx) => (
                <tr key={idx} className="border-b hover:bg-gray-50 transition">
                  <td className="py-2 px-2">{idx + 1}</td>
                  <td
                    className="py-2 px-2 font-mono font-bold text-indigo-600 cursor-pointer"
                    onClick={() => handleViewClick(row)}
                  >
                    <TruncatedText text={row.grievance_id || ""} limit={6} />
                  </td>
                  <td className="py-2 px-4 text-gray-800">
                    <TruncatedText text={row.source || "CAG"} limit={20} />
                  </td>
                  <td className="py-2 px-2 text-gray-800">
                    <TruncatedText text={row.user_query || ""} limit={25} />
                  </td>
                  <td className="py-2 px-2 text-gray-800">
                    <TruncatedText text={row.llm_category || ""} limit={30} />
                  </td>
                  <td className="py-2 px-2">
                    <span
                      className={`min-w-[100px] inline-block text-center px-3 py-1 text-xs font-medium rounded-full
                            ${row.officer_grievance_status?.toLowerCase() ===
                          "resolved"
                          ? "bg-green-600 text-white" // dark yellow
                          : "bg-yellow-600 text-white" // green
                        }
                         `}
                    >
                      {toSentenceCase(row.officer_grievance_status || "")}
                    </span>
                  </td>
                  <td className="py-2 px-2 text-gray-800">
                    <TruncatedText
                      text={row.grievance_response || ""}
                      limit={20}
                    />
                  </td>
                  <td className="py-2 px-2 text-gray-800">
                    <TruncatedText text={row.atr_summary || ""} limit={20} />
                  </td>
                  {/* <td className="py-2 px-2 text-center">
                      <div className="flex justify-center items-center gap-2">
                        <VisibilityIcon
                          fontSize="small"
                          className={`
                              cursor-pointer
                              ${row.officer_grievance_status?.toLowerCase() === 'resolved'
                              ? 'text-green-600 hover:text-green-700'
                              : 'text-yellow-600 hover:text-yellow-700'
                            }
  `}
                          onClick={() => handleViewATR(row)}
                        />

                      </div>
                    </td> */}
                  {/* <td className="py-2 px-2 text-gray-800">
                      <TruncatedText text={row.atr_category || ""} limit={20} />
                    </td> */}
                  <td className="py-2 px-2 text-gray-800">
                    <TruncatedText
                      text={row.feedback_call_summary || ""}
                      limit={20}
                    />
                  </td>
                  {/* <td className="py-2 px-2 text-center">
                      <div className="flex justify-center items-center gap-2">
                        <VisibilityIcon
                          fontSize="small"
                          className={`
    cursor-pointer
    ${row.officer_grievance_status?.toLowerCase() === 'resolved'
                              ? 'text-green-600 hover:text-green-700'
                              : 'text-yellow-600 hover:text-yellow-700'
                            }
  `}
                          onClick={() => handleViewFeedback(row)}
                        />

                      </div>
                    </td> */}
                  <td
                    className={`py-2 px-2 ${[
                        "संतुष्ट",
                        "satisfied",
                        "very_satisfied",
                        "very satisfied",
                      ].includes(row.feedback_call_category?.toLowerCase())
                        ? "text-green-600"
                        : [
                          "संतुष्ट नहीं",
                          "unsatisfied",
                          "not satisfied",
                          "very_unsatisfied",
                          "very unsatisfied",
                        ].includes(
                          row.feedback_call_category?.toLowerCase(),
                        )
                          ? "text-red-600"
                          : "text-yellow-600"
                      }`}
                  >
                    <TruncatedText
                      text={
                        formatFeedbackCategory(row.feedback_call_category) || ""
                      }
                      limit={20}
                    />
                  </td>
                  <td
                    className={`py-2 px-2 font-medium ${row.severity?.toLowerCase() === "critical" ||
                        row.severity?.toLowerCase() === "high"
                        ? "text-red-600"
                        : row.severity?.toLowerCase() === "semi-critical" ||
                          row.severity?.toLowerCase() === "medium"
                          ? "text-yellow-600"
                          : "text-gray-800"
                      }`}
                  >
                    <TruncatedText text={row.severity || ""} limit={20} />
                  </td>
                  <td className="py-2 px-4 text-gray-600">
                    {new Date(
                      row.grievance_submission_timestamp,
                    ).toLocaleDateString("en-IN")}
                  </td>
                  <td className="py-2 px-2 text-gray-800">
                    <TruncatedText text={row.tat || ""} limit={20} />
                  </td>
                  <td className="py-2 px-4 text-gray-600">
                    {calculateDaysLapsed(row)}
                    {/* {new Date(row.grievance_submission_timestamp).toLocaleDateString('en-IN')} */}
                  </td>
                  <td className="py-2 px-2">
                    <div className="flex justify-center items-center gap-2">
                      {row.admin_feedback ? (
                        <VisibilityIcon
                          fontSize="small"
                          className="cursor-pointer
                        text-green-600 hover:text-green-700"
                          onClick={() => handleViewComment(row)}
                        />
                      ) : (
                        <EditIcon
                          fontSize="small"
                          className="
                          cursor-pointer
                          text-yellow-600 hover:text-yellow-700
                        "
                          onClick={() => handleEditComment(row)}
                        />
                      )}
                    </div>
                  </td>

                  <td className="py-2 px-2 text-center">
                    {row.officer_grievance_status?.toLowerCase() !==
                      "resolved" && (
                        <button
                          className="py-2 px-2 bg-blue-500 text-white rounded hover:bg-blue-600"
                          onClick={() => handleNotifyOfficer(row)}
                        >
                          Remind
                        </button>
                      )}
                  </td>

                  {/* <td className="py-2 px-2 text-center">
                      <div className="flex justify-center items-center gap-2">
                        <VisibilityIcon
                          fontSize="small"
                          className={`
    cursor-pointer
    ${row.officer_grievance_status?.toLowerCase() === 'pending'
                              ? 'text-yellow-600 hover:text-yellow-700'
                              : row.officer_grievance_status?.toLowerCase() === 'responded'
                                ? 'text-green-600 hover:text-green-700'
                                : 'text-black hover:text-gray-800'
                            }
  `}
                          onClick={() => handleViewClick(row)}
                        />
                       
                      </div>
                    </td> */}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="w-full flex">
          <button
            onClick={downloadPDF}
            className="bg-blue-600 text-white px-2 py-2 rounded ml-auto mt-3"
          >
            Download PDF
          </button>
        </div>
      </div>
      {/* <div className='h-[70vh] w-full mt-4'>
        <iframe
          src="https://sea-lion-app-xp7yb.ondigitalocean.app/feedback"
          width="100%"
          height="100%"
          style={{ border: "none" }}
          title="Feedback"
        />
      </div> */}
      {/* Modal */}
      <div className="bg-white  w-full">
        {isATROpen && selectedRow && (
          <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 ">
            <div className="bg-white w-[95vw] sm:w-[80vw] max-w-4xl p-5 sm:p-6 rounded shadow-lg max-h-[85vh] overflow-auto">
              <h3 className="text-lg font-bold mb-4">View ATR</h3>
              <form className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    ATR Summary
                  </label>
                  <textarea
                    type="text"
                    name="llm_response_desc"
                    value={selectedRow.atr_summary}
                    readOnly={isViewOnly}
                    className="mt-1 w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring focus:ring-blue-300"
                    rows={5} // You can adjust the number of rows as per your requirement
                  ></textarea>
                </div>
                <div className="flex justify-end space-x-4">
                  <button
                    type="button"
                    className="px-2 py-2 bg-gray-500 text-white rounded hover:bg-gray-600"
                    onClick={handleCloseATR}
                  >
                    Close
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}
        {isFeedbackOpen && selectedRow && (
          <div className="fixed inset-0 flex items-start sm:items-center justify-center bg-black bg-opacity-50 p-4 sm:p-0">
            <div className="bg-white w-full sm:w-[80vw] max-w-4xl p-5 sm:p-6 rounded shadow-lg max-h-[85vh] sm:max-h-[85vh] overflow-auto mt-6 sm:mt-0">
              <h3 className="text-lg font-bold mb-4">View Feedback</h3>
              <form className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    Feedback Summary
                  </label>
                  <textarea
                    type="text"
                    name="llm_response_desc"
                    value={selectedRow.feedback_call_summary}
                    readOnly={isViewOnly}
                    className="mt-1 w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring focus:ring-blue-300"
                    rows={5} // You can adjust the number of rows as per your requirement
                  ></textarea>
                </div>
                <div className="flex justify-end space-x-4">
                  <button
                    type="button"
                    className="px-2 py-2 bg-gray-500 text-white rounded hover:bg-gray-600"
                    onClick={handleCloseFeedback}
                  >
                    Close
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}

        {isCommentOpen && selectedRow && (
          <div className="fixed inset-0 flex items-start sm:items-center justify-center bg-black bg-opacity-50 p-4 sm:p-0">
            <div className="bg-white w-full sm:w-[80vw] max-w-4xl p-5 sm:p-6 rounded shadow-lg max-h-[85vh] sm:max-h-[85vh] overflow-auto mt-6 sm:mt-0">
              <h3 className="text-lg font-bold mb-4">View Feedback</h3>
              <form className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    Comment Summary
                  </label>
                  <textarea
                    type="text"
                    name="llm_response_desc"
                    value={adminComment || selectedRow.admin_feedback}
                    readOnly={isViewOnly}
                    onChange={(e) => setAdminComment(e.target.value)}
                    className="mt-1 w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring focus:ring-blue-300"
                    rows={5} // You can adjust the number of rows as per your requirement
                  ></textarea>
                </div>
                <div className="flex justify-end space-x-4">
                  <button
                    type="button"
                    className="px-2 py-2 bg-gray-500 text-white rounded hover:bg-gray-600"
                    onClick={handleCloseComment}
                  >
                    Close
                  </button>

                  {adminComment && (
                    <button
                      type="button"
                      className="px-2 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
                      onClick={saveAdminComment}
                    >
                      {loading ? "Saving..." : "Save"}
                    </button>
                  )}
                </div>
              </form>
            </div>
          </div>
        )}
        {isAdminModalOpen && selectedRow && (
          <div className="fixed inset-0 flex items-start sm:items-center justify-center bg-black bg-opacity-50 p-4 sm:p-0">
            <div className="bg-white w-full sm:w-[80vw] max-w-4xl p-5 sm:p-6 rounded shadow-lg max-h-[85vh] sm:max-h-[90vh] overflow-auto mt-6 sm:mt-0">
              <h3 className="text-lg font-bold mb-4">Grievance Summary</h3>
              <form className="space-y-4">
                {/* Query Title */}
                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    User Grievance
                  </label>
                  <input
                    type="text"
                    name="user_query"
                    value={selectedRow.user_query}
                    readOnly={true}
                    className="mt-1 w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring focus:ring-blue-300"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    Bot Response
                  </label>
                  <textarea
                    name="llm_response_desc"
                    value={selectedRow.llm_response_desc}
                    // onChange={handleInputChange}
                    readOnly={true}
                    className="mt-1 w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring focus:ring-blue-300"
                    rows={3} // You can adjust the number of rows as per your requirement
                  ></textarea>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    Comment from Officer
                  </label>
                  <textarea
                    name="officer_grievance_comments"
                    value={
                      selectedRow?.officer_transfer_comments ||
                      selectedRow?.grievance_response
                    }
                    readOnly={true}
                    className="mt-1 w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring focus:ring-blue-300"
                    rows={3} // You can adjust the number of rows as per your requirement
                  ></textarea>
                </div>
                {/* Response from expert */}
                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    Comment from Admin
                  </label>
                  <textarea
                    name="officer_grievance_comments"
                    value={
                      selectedRow?.officer_grievance_comments ||
                      selectedRow?.grievance_response
                    }
                    onChange={handleInputChange}
                    className="mt-1 w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring focus:ring-blue-300"
                    rows={3} // You can adjust the number of rows as per your requirement
                  ></textarea>
                </div>

                {/* <div>
                  <label className="block text-sm font-medium text-gray-700">
                    Ministry
                  </label>
                  <input
                    type="text"
                    name="llm_ministry"
                    value={selectedRow.llm_ministry}
                    readOnly={true}
                    className="mt-1 w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring focus:ring-gray-300"
                  />
                </div> */}
                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    Department
                  </label>
                  <input
                    type="text"
                    name="llm_category"
                    value={selectedRow.llm_category}
                    readOnly={true}
                    className="mt-1 w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring focus:ring-gray-300"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    Sub Category
                  </label>
                  <input
                    type="text"
                    name="llm_subcategory"
                    value={selectedRow.llm_subcategory}
                    readOnly={true}
                    className="mt-1 w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring focus:ring-gray-300"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    State
                  </label>
                  <input
                    type="text"
                    name="state"
                    value={selectedRow.state || ""}
                    readOnly={true}
                    className="mt-1 w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring focus:ring-gray-300"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    District
                  </label>
                  <input
                    type="text"
                    name="district"
                    value={selectedRow.district}
                    readOnly={true}
                    className="mt-1 w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring focus:ring-gray-300"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    Severity
                  </label>
                  <input
                    type="text"
                    name="severity"
                    value={selectedRow.severity}
                    readOnly={true}
                    className="mt-1 w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring focus:ring-gray-300"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    User Id
                  </label>
                  <input
                    type="text"
                    name="user_id"
                    value={selectedRow.user_id}
                    readOnly={true}
                    className="mt-1 w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring focus:ring-blue-300"
                  />
                </div>

                {/* ATR Upload & Summary Section - only for responded grievances */}
                {(selectedRow.atr_uploaded ||
                  selectedRow?.officer_grievance_status?.toLowerCase() ===
                  "attach atr") && (
                    <div className="bg-gray-50 p-4 rounded-lg border">
                      <h4 className="text-md font-semibold text-gray-800 mb-2">
                        ATR Management
                      </h4>

                      {/* Upload Controls - only show when no summary exists yet */}
                      {!decodeSummary(selectedRow?.atr_summary).summary &&
                        !atrSummary && (
                          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-2 sm:gap-4 mb-4">
                            <input
                              type="file"
                              accept=".pdf"
                              onChange={(e) => setAtrFile(e.target.files[0])}
                              className="flex-1 px-3 py-2 border rounded-lg focus:outline-none focus:ring focus:ring-green-300 text-sm"
                            />
                            <button
                              type="button"
                              className="px-4 py-2 w-full sm:w-auto bg-green-500 text-white rounded hover:bg-green-600 font-medium disabled:opacity-50"
                              onClick={handleAtrUpload}
                              disabled={atrUploadLoading || !atrFile}
                            >
                              {atrUploadLoading ? "Uploading..." : "Upload ATR"}
                            </button>
                          </div>
                        )}

                      {/* Summary Display - show from fresh upload or from backend */}
                      {(atrSummary ||
                        decodeSummary(selectedRow?.atr_summary).summary) && (
                          <div className="mt-2">
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                              ATR Summary
                            </label>
                            <div className="w-full px-3 py-3 border rounded-lg bg-white text-gray-700 text-sm max-h-48 overflow-y-auto whitespace-pre-wrap">
                              {atrSummary ||
                                decodeSummary(selectedRow?.atr_summary).summary}
                            </div>
                          </div>
                        )}

                      {/* Download ATR Button - only show after save (persisted in backend) */}
                      {!atrSummary &&
                        (selectedRow.atr_file_url ||
                          (!atrFileUrl &&
                            decodeSummary(selectedRow?.atr_summary).fileUrl)) && (
                          <div className="mt-4">
                            <button
                              type="button"
                              className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 font-medium"
                              onClick={() => handleATR(selectedRow.grievance_id)}
                            >
                              Download ATR
                            </button>
                          </div>
                        )}
                    </div>
                  )}

                {/* Audio Upload Section - only show after ATR summary is available */}
                {selectedRow?.officer_grievance_status?.toLowerCase() ===
                  "resolved" &&
                  (atrSummary ||
                    decodeSummary(selectedRow?.atr_summary).summary) && (
                    <div className="bg-gray-50 p-4 rounded-lg border mt-4">
                      <h4 className="text-md font-semibold text-gray-800 mb-2">
                        Audio Upload
                      </h4>
                      {!(
                        selectedRow.feedback_call_uploaded &&
                        selectedRow.feedback_call_summary
                      ) && (
                          <div className="mt-4">
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                              Audio File
                            </label>
                            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-2 sm:gap-4">
                              <input
                                type="file"
                                accept="audio/*"
                                onChange={(e) => setAudioFile(e.target.files[0])}
                                className="flex-1 px-3 py-2 border rounded-lg focus:outline-none focus:ring focus:ring-green-300 text-sm"
                              />
                              <button
                                type="button"
                                className="px-4 py-2 w-full sm:w-auto bg-green-500 text-white rounded hover:bg-green-600 font-medium disabled:opacity-50"
                                onClick={handleAudioUpload}
                                disabled={audioUploadLoading || !audioFile}
                              >
                                {audioUploadLoading
                                  ? "Uploading..."
                                  : "Upload Audio"}
                              </button>
                            </div>
                          </div>
                        )}
                      {(audioSummary ||
                        decodeSummary(selectedRow?.atr_summary).summary) && (
                          <div className="mt-4">
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                              Audio Summary
                            </label>
                            <div className="w-full px-3 py-3 border rounded-lg bg-white text-gray-700 text-sm max-h-48 overflow-y-auto whitespace-pre-wrap">
                              {audioSummary ||
                                decodeSummary(selectedRow?.feedback_call_summary)
                                  .summary}
                            </div>
                          </div>
                        )}
                      {/* {audioFileUrl && (
                      <div className="mt-4">
                        <button
                          type="button"
                          className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 font-medium"
                          onClick={handleAudioDownload}
                        >
                          Download Audio
                        </button>
                      </div>
                    )} */}
                    </div>
                  )}

                {/* Buttons */}
                <div className="flex flex-wrap justify-end gap-2 sm:gap-4 pt-4 border-t">
                  {/* {selectedRow?.officer_grievance_status === "Add Comment" && <button
                    type="button"
                    className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
                    onClick={handleTransfer}
                  >
                    Transfer
                  </button>} */}
                  <button
                    type="button"
                    className="px-4 py-2 bg-gray-500 text-white rounded hover:bg-gray-600 whitespace-nowrap flex-1 sm:flex-none text-center"
                    onClick={handleClose}
                  >
                    Cancel
                  </button>
                  {/* Show Save for: pending grievances OR responded with freshly uploaded ATR OR freshly uploaded Audio */}
                  {(selectedRow?.officer_grievance_status?.toLowerCase() !==
                    "resolved" ||
                    atrSummary ||
                    audioSummary) && (
                      <button
                        type="button"
                        className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 whitespace-nowrap flex-1 sm:flex-none text-center"
                        onClick={handleSave}
                      >
                        {loading ? "Saving..." : "Save"}
                      </button>
                    )}
                </div>
              </form>
            </div>
          </div>
        )}

        {isModalOpen && selectedRow && (
          <div className="fixed inset-0 flex items-start sm:items-center justify-center bg-black bg-opacity-50 p-4 sm:p-0">
            <div className="bg-white w-full sm:w-[80vw] max-w-4xl p-5 sm:p-6 rounded shadow-lg max-h-[85vh] sm:max-h-[85vh] overflow-auto mt-6 sm:mt-0">
              <h3 className="text-lg font-bold mb-4">View Grievance</h3>
              <form className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    User Grievance
                  </label>
                  <input
                    type="text"
                    name="user_query"
                    value={selectedRow.user_query}
                    readOnly={isViewOnly}
                    className="mt-1 w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring focus:ring-gray-300"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    Bot Response
                  </label>
                  <textarea
                    type="text"
                    name="llm_response_desc"
                    value={selectedRow.llm_response_desc}
                    readOnly={isViewOnly}
                    className="mt-1 w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring focus:ring-blue-300"
                    rows={3} // You can adjust the number of rows as per your requirement
                  ></textarea>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    Comment from officer
                  </label>
                  <textarea
                    name="officer_grievance_comments"
                    value={
                      selectedRow?.officer_grievance_comments ||
                      selectedRow?.grievance_response
                    }
                    readOnly={isViewOnly}
                    className="mt-1 w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring focus:ring-blue-300"
                    rows={3} // You can adjust the number of rows as per your requirement
                  ></textarea>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    User Id
                  </label>
                  <input
                    type="text"
                    name="user_id"
                    value={selectedRow.user_id}
                    readOnly={isViewOnly}
                    className="mt-1 w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring focus:ring-gray-300"
                  />
                </div>
                {/* <div>
                  <label className="block text-sm font-medium text-gray-700">
                    Ministry
                  </label>
                  <input
                    type="text"
                    name="llm_ministry"
                    value={selectedRow.llm_ministry}
                    readOnly={isViewOnly}
                    className="mt-1 w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring focus:ring-gray-300"
                  />
                </div> */}
                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    Department
                  </label>
                  <input
                    type="text"
                    name="llm_category"
                    value={selectedRow.llm_category}
                    readOnly={isViewOnly}
                    className="mt-1 w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring focus:ring-gray-300"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    Sub Category
                  </label>
                  <input
                    type="text"
                    name="llm_subcategory"
                    value={selectedRow.llm_subcategory}
                    readOnly={isViewOnly}
                    className="mt-1 w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring focus:ring-gray-300"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    State
                  </label>
                  <input
                    type="text"
                    name="state"
                    value={selectedRow.state || ""}
                    readOnly={isViewOnly}
                    className="mt-1 w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring focus:ring-gray-300"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    ATR Summary
                  </label>
                  <textarea
                    type="text"
                    name="district"
                    value={selectedRow.atr_summary}
                    readOnly={isViewOnly}
                    className="mt-1 w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring focus:ring-gray-300"
                    rows={5}
                  ></textarea>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    Feedback Call Summary
                  </label>
                  <textarea
                    type="text"
                    name="feedback"
                    value={selectedRow.feedback_call_summary}
                    readOnly={isViewOnly}
                    className="mt-1 w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring focus:ring-gray-300"
                    rows={5}
                  ></textarea>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    Severity
                  </label>
                  <input
                    type="text"
                    name="severity"
                    value={selectedRow.severity}
                    readOnly={isViewOnly}
                    className="mt-1 w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring focus:ring-gray-300"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    Status
                  </label>
                  <input
                    type="text"
                    name="status"
                    value={selectedRow.officer_grievance_status}
                    readOnly={isViewOnly}
                    className="mt-1 w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring focus:ring-gray-300"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    User FeedBack
                  </label>
                  <textarea
                    type="text"
                    name="city"
                    value={selectedRow.user_grievance_feedback_comments}
                    readOnly={isViewOnly}
                    className="mt-1 w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring focus:ring-gray-300"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    Admin FeedBack
                  </label>
                  <textarea
                    type="text"
                    name="status"
                    value={selectedRow.admin_feedback}
                    readOnly={isViewOnly}
                    className="mt-1 w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring focus:ring-gray-300"
                  />
                </div>
                {/* <div>
                  {selectedRow.status === "Responded" && (
                    <button
                      className={`w-20 px-2 py-2 text-white rounded mr-2 ${isLiked
                        ? "bg-blue-700 hover:bg-blue-800"
                        : "bg-blue-500 hover:bg-blue-600"
                        }`}
                      onClick={handleLikeClick}
                    >
                      {isLiked ? "Liked" : "Like"}
                    </button>
                  )}

                  {selectedRow.status === "Responded" && (
                    <button
                      className="w-20 px-2 py-2 bg-red-500 text-white rounded hover:bg-red-600"
                      onClick={handleDislikeClick}
                    >
                      Dislike
                    </button>
                  )}

                  {showCommentArea && (
                    <div className="mt-4">
                      <textarea
                        placeholder="Please provide your comment..."
                        className="w-full p-2 border border-gray-300 rounded"
                        rows="4"
                        onChange={(e) => setComment(e.target.value)} // Save comment to state
                      />
                    </div>
                  )}
                </div> */}

                <div className="flex justify-end space-x-4">
                  <button
                    type="button"
                    className="px-2 py-2 bg-gray-500 text-white rounded hover:bg-gray-600"
                    onClick={handleClose}
                  >
                    Close
                  </button>
                  {/* {selectedrow.officer_grievance_status?.toLowerCase() !== "responded" && (
                    <button
                      type="button"
                      className="px-2 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
                      onClick={handleSave1}
                    >
                      {saveLoading ? "Saving..." : "Save"}
                    </button>
                  )} */}
                </div>
              </form>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export const getGrievance = async (id) => {
  try {
    const res = await axios.get(`${AUTH_URL}api/grievance?grievance_id=${id}`, {
      headers: { "Content-Type": "application/json" },
    });

    return res.data?.data;
  } catch (error) {
    alert("Data not found");
  }
};
